import React from 'react';

export const REVISION = 'd5681417-d5dd-43df-94c0-715ad5548091';

export const ITEMS = [
    // {
    //     selector: 'auth-widget',
    //     title: 'We have updated the license widget!',
    //     description: [
    //         <>
    //             <strong>License usage statistics</strong> and <strong>Log out</strong> are now also located here
    //         </>,
    //         'We will notify you when the expiration date or credits are nearing their end'
    //     ]
    // },
    // {
    //     selector: 'setting-menu-item',
    //     title: null,
    //     description: (
    //         <>
    //             <strong>Profile, License, API keys</strong>, and <strong>Security</strong> have moved to the Settings
    //             section
    //         </>
    //     )
    // }
    {
        selector: 'sbom-audit-menu-item',
        title: 'Introducing SBOM Package Analysis',
        description: (
            <>
                <p>
                    SBOM (Software Bill of Materials) is a standardized inventory of all software components in a system
                    — OS packages, libraries, containers and transitive dependencies.It provides full-stack visibility
                    and enables vulnerability detection across the entire software stack.
                </p>
                <br />
                <ul>
                    <li>Standardized description of all software components</li>
                    <li>Used and promoted by OWASP, NIST and DoD</li>
                    <li>Enables vulnerability detection across the entire technology stack</li>
                </ul>
            </>
        )
    },
    {
        selector: 'sbom-audit-menu-item',
        title: 'Why is it important?',
        description: (
            <>
                <p>Vulners enriches your SBOM with actionable security intelligence.</p>
                <br />
                <ul>
                    <li>High-coverage CVE and advisory correlation</li>
                    <li>AI-based risk scoring and EPSS prioritization</li>
                    <li>Normalization across OS, package managers, and language ecosystems</li>
                    <li>Clear remediation insights for affected packages</li>
                </ul>
            </>
        )
    },
    {
        selector: 'sbom-audit-menu-item',
        title: 'What does Vulners provide',
        description: (
            <>
                <p>Automate SBOM analysis across your infrastructure.</p>
                <br />
                <ul>
                    <li>Send SBOM files to the Vulners API</li>
                    <li>Receive structured vulnerability reports</li>
                    <li>Integrate results into CI/CD and security workflows</li>
                </ul>
            </>
        )
    }
];
